var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.9668 13.8758C11.8632 13.8806 11.7622 13.9084 11.6719 13.957L8.02669 15.9171L6.75977 15.7473C6.66529 15.7346 6.56905 15.7414 6.47756 15.7672C6.38607 15.793 6.30145 15.8371 6.22943 15.8967C6.15741 15.9563 6.09965 16.0298 6.06007 16.1125C6.02049 16.1951 6.00001 16.2849 6 16.3757V18.3489C5.99997 18.457 6.02896 18.5633 6.08422 18.6578C6.13948 18.7523 6.21918 18.8317 6.31576 18.8886L11.6491 22.03C11.7545 22.0921 11.876 22.125 12 22.125C12.124 22.125 12.2455 22.0921 12.3509 22.03L17.6842 18.8886C17.7808 18.8317 17.8605 18.7523 17.9158 18.6578C17.971 18.5633 18 18.457 18 18.3489V16.1848C17.9999 16.0804 17.9728 15.9777 17.921 15.8857C17.8692 15.7936 17.7944 15.7152 17.7032 15.6573C17.612 15.5994 17.5071 15.5638 17.398 15.5536C17.2888 15.5435 17.1787 15.5591 17.0775 15.5992L15.9232 16.0553L12.3483 13.9687C12.2339 13.9019 12.1009 13.8695 11.9668 13.8758Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9668 13.5008C11.8632 13.5056 11.7622 13.5334 11.6719 13.582L8.02669 15.5421L6.75977 15.3723C6.66529 15.3596 6.56905 15.3664 6.47756 15.3922C6.38607 15.418 6.30145 15.4621 6.22943 15.5217C6.15741 15.5813 6.09965 15.6548 6.06007 15.7375C6.02049 15.8201 6.00001 15.9099 6 16.0007V17.9739C5.99997 18.082 6.02896 18.1883 6.08422 18.2828C6.13948 18.3773 6.21918 18.4567 6.31576 18.5136L11.6491 21.655C11.7545 21.7171 11.876 21.75 12 21.75C12.124 21.75 12.2455 21.7171 12.3509 21.655L17.6842 18.5136C17.7808 18.4567 17.8605 18.3773 17.9158 18.2828C17.971 18.1883 18 18.082 18 17.9739V15.8098C17.9999 15.7054 17.9728 15.6027 17.921 15.5107C17.8692 15.4186 17.7944 15.3402 17.7032 15.2823C17.612 15.2244 17.5071 15.1888 17.398 15.1786C17.2888 15.1685 17.1787 15.1841 17.0775 15.2242L15.9232 15.6803L12.3483 13.5937C12.2339 13.5269 12.1009 13.4945 11.9668 13.5008Z",
    fill: "#1383D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.375 10.125L12 13.875L5.625 10.125L12 6.375L18.375 10.125Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.5 2.625L1.5 6.75L5.625 10.125L1.5 13.5L7.5 17.625L12 13.875L16.5 17.5005L22.5 13.5L18.375 10.125L22.5 6.75L16.5 2.625L12 6.375L7.5 2.625Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.25L1.5 6.375L5.625 9.75L1.5 13.125L7.5 17.25L12 13.5L16.5 17.1255L22.5 13.125L18.375 9.75L22.5 6.375L16.5 2.25L12 6L7.5 2.25Z",
    fill: "#5AACFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.375 10.125L12 13.875L5.625 10.125L12 6.375L18.375 10.125Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 9.75L12 13.5L5.625 9.75L12 6L18.375 9.75Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.5 2.25L1.5 6.375L1.74902 6.57861L7.5 2.625L12 6.375L16.5 2.625L22.251 6.57861L22.5 6.375L16.5 2.25L12 6L7.5 2.25ZM5.39575 9.9375L1.5 13.125L1.74902 13.2964L5.625 10.125L5.39575 9.9375ZM18.6042 9.9375L18.375 10.125L22.2473 13.2935L22.5 13.125L18.6042 9.9375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropbox);
export default __webpack_public_path__ + "static/media/dropbox.d9ff7ff404dd6d0a9be35aa83127a518.svg";
export { ForwardRef as ReactComponent };